import React, { useState, useEffect } from 'react';
import './HamburgerMenu.css';

// Mobile-only hamburger nav. Replaces the previous bottom-tab bar. The
// trigger button sits in the top-left corner; tapping opens a slide-from-left
// drawer overlay. Dismisses on outside-tap, ESC, or route selection.
//
// activeScreen highlights the current section; onNavigate is the same
// four-item contract we used for BottomNav so App.js wiring stays 1:1.
const ITEMS = [
  { id: 'menu',        label: 'Play',        icon: '♚' },
  { id: 'puzzles',     label: 'Puzzles',     icon: '🧩' },
  { id: 'my-games',    label: 'Games',       icon: '📂' },
  { id: 'leaderboard', label: 'Leaderboard', icon: '🏆' },
  { id: 'rules',       label: 'Rules',       icon: '📖' },
  { id: 'settings',    label: 'Profile',     icon: '👤' },
];

const SCREEN_TO_ITEM = {
  menu: 'menu',
  setup: 'menu',
  game: 'menu',
  'online-game': 'menu',
  matchmaking: 'menu',
  tutorial: 'menu',
  puzzles: 'puzzles',
  'puzzle-board': 'puzzles',
  'endgame-trainer': 'puzzles',
  'my-games': 'my-games',
  analysis: 'my-games',
  leaderboard: 'leaderboard',
  rules: 'rules',
  settings: 'settings',
};

export default function HamburgerMenu({ currentScreen, onNavigate }) {
  const [open, setOpen] = useState(false);
  const activeItem = SCREEN_TO_ITEM[currentScreen] || 'menu';

  // Dismiss the drawer on ESC — small keyboard-a11y niceness, not
  // strictly required for touch but costs nothing.
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') setOpen(false); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open]);

  const handlePick = (id) => {
    setOpen(false);
    onNavigate(id);
  };

  return (
    <>
      <button
        type="button"
        className="hamburger-trigger"
        onClick={() => setOpen(true)}
        aria-label="Open menu"
        aria-expanded={open}
      >
        <span aria-hidden="true">☰</span>
      </button>

      {open && (
        <div
          className="hamburger-scrim"
          onClick={() => setOpen(false)}
          role="presentation"
        />
      )}

      <nav
        className={`hamburger-drawer ${open ? 'open' : ''}`}
        role="navigation"
        aria-label="Primary"
        aria-hidden={!open}
      >
        <div className="hamburger-drawer-header">
          <div className="hamburger-brand">Ranga</div>
          <button
            type="button"
            className="hamburger-close"
            onClick={() => setOpen(false)}
            aria-label="Close menu"
          >
            ×
          </button>
        </div>
        <ul className="hamburger-items">
          {ITEMS.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                className={`hamburger-item ${activeItem === item.id ? 'active' : ''}`}
                onClick={() => handlePick(item.id)}
              >
                <span className="hamburger-item-icon" aria-hidden="true">{item.icon}</span>
                <span className="hamburger-item-label">{item.label}</span>
              </button>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
}
